import { Component, OnDestroy, OnInit } from '@angular/core';
import { SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MessageService } from 'primeng/api';
import { Subject, takeUntil } from 'rxjs';
import { ErrorMessage, ErrorType } from 'src/app/shared/entity/error.const';
import { DataAccessService } from 'src/app/shared/services/data-access/data-access.service';
import { DataRepositoryService } from 'src/app/shared/services/data-repository/data-repository.service';
import { UserColumnPreferencesService } from '../setting/column-preference/user-column-preferences-service/user-column-preferences.service';
import { ColumnService } from 'src/app/shared/services/column-services/column.service';
import { ConnectionStatus } from 'src/app/shared/entity/enums';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    standalone: false
})
export class LayoutComponent implements OnInit, OnDestroy {

  hideAppOptions: boolean = true;
  isOffline: boolean = false;
  offlineStatusMessage = ErrorMessage.OFFLINESTATUS;
  sanitizedToastDetail: SafeHtml | string = '';
  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly dataAccessService : DataAccessService,
    private readonly messageService :MessageService,
    private readonly dataRepositoryService: DataRepositoryService,
    private readonly userColumnPreferenceService: UserColumnPreferencesService,
    private readonly columnService: ColumnService,
    private readonly sanitizer: DomSanitizer
  ) { }

  private sanitizeToastDetail(detail: string | undefined): void {
    this.sanitizedToastDetail = this.sanitizer.sanitize(SecurityContext.HTML, detail ?? null) ?? '';
  }


  appOptionsStatus(status: boolean) {
    this.hideAppOptions = status;
  }
  ngOnInit(){
    this.messageService.messageObserver.pipe(takeUntil(this.destroy$)).subscribe((message) => {
      if (Array.isArray(message)) {
        this.sanitizeToastDetail(message.length ? message[message.length - 1]?.detail : undefined);
        return;
      }
      this.sanitizeToastDetail(message?.detail);
    });

    this.dataAccessService.isSelectedRouteEmpty$.pipe(takeUntil(this.destroy$)).subscribe((isRouteEmpty :boolean) =>{
        if(isRouteEmpty){
        this.messageService.add({
          severity:ErrorType.WARNING,
          summary : "",
          detail:ErrorMessage.NOTASKONROUTE,
        })
      }

    })
    if (!this.dataRepositoryService.userColumnPreferencesList().length) {
      this.userColumnPreferenceService.getUserColumnPreference();
    }
    if(this.dataRepositoryService.selectedUserColumnPreferences() === null) {
      this.columnService.getSelectedUserColumnPreference();
    }

    this.dataAccessService.connectionSubscription$.pipe(takeUntil(this.destroy$)).subscribe(
      (connectionStatus: string) => {
        if (connectionStatus.toLowerCase() === ConnectionStatus.Offline) {
          this.isOffline = true;
        }
        if (connectionStatus.toLowerCase() === ConnectionStatus.Online) {
          this.isOffline = false;
        }
      }
    );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
